import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React from 'react';
import checkIsMobile from 'utils/CheckIsMobile';
import 'assets/scss/portabilidad-container.scss';
import { ControlLayout } from 'components/ControlLayout';
import { StageBar } from 'components/StageBar';

type MultiFromProps = {
	currentStep: number;
	controlConfig: ActionButtonConfig[];
	views: JSX.Element[];
	isError: boolean;
};

export const MultiFormContainer = ({
	controlConfig,
	views,
	currentStep,
	isError,
}: MultiFromProps) => {
	const configAction: ActionButtonConfig[] = controlConfig;

	const classContainer = checkIsMobile()
	? 'portabilidad-container'
	: 'portabilidad-container card-box';

	return (
		<div className={classContainer}>
			<StageBar value={currentStep + 1} maxValue={configAction.length} />

			{
				{
					...views,
				}[currentStep]
			}

			<ControlLayout
				inputError={isError}
				disableBackButton={configAction[currentStep].buttonBackName === ''}
				handleBackClick={configAction[currentStep].buttonBackClick}
				handleNextClick={configAction[currentStep].buttonNextClick}
				buttonBackName={configAction[currentStep].buttonBackName}
				buttonNextName={configAction[currentStep].buttonNextName}
			/>
		</div>
	);
};
